import { render, staticRenderFns } from "./d-user-follow-panel.vue?vue&type=template&id=8ecff552&scoped=true&"
import script from "./d-user-follow-panel.vue?vue&type=script&lang=js&"
export * from "./d-user-follow-panel.vue?vue&type=script&lang=js&"
import style0 from "./d-user-follow-panel.vue?vue&type=style&index=0&id=8ecff552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecff552",
  null
  
)

export default component.exports